import {NgModule} from '@angular/core';
import {DownloadFileComponent} from './download-file.component';

@NgModule({
  declarations: [
    DownloadFileComponent
  ],
  exports: [
    DownloadFileComponent
  ]
})
export class DownloadFileModule {
}
